import { RSAA } from 'redux-api-middleware';

import { toFormData } from '../../helpers/requestHelper';
import {
  TemplateUpdateFormDataProps,
  TemplateUploadFormDataProps,
} from '../../components/clipGeneratorV2/templates/forms/templateForm.types';

const BASE_ROUTE = `/after-effects/clip-templates`;

const GET_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST = 'GET_CLIP_TEMPLATE_REQUEST';
const GET_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS = 'GET_CLIP_TEMPLATE_SUCCESS';
const GET_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE = 'GET_CLIP_TEMPLATE_FAILURE';

export const getAfterEffectsClipTemplates = () => ({
  [RSAA]: {
    types: [
      GET_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST,
      GET_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS,
      GET_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'GET',
  },
});

const UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST = 'UPLOAD_CLIP_TEMPLATE_REQUEST';
const UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS = 'UPLOAD_CLIP_TEMPLATE_SUCCESS';
const UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE = 'UPLOAD_CLIP_TEMPLATE_FAILURE';

export const uploadAfterEffectsClipTemplate = (body: TemplateUploadFormDataProps) => ({
  [RSAA]: {
    types: [
      UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST,
      UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS,
      UPLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}`,
    method: 'POST',
    body: toFormData(body),
  },
});

const DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST = 'DELETE_CLIP_TEMPLATE_REQUEST';
const DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS = 'DELETE_CLIP_TEMPLATE_SUCCESS';
const DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE = 'DELETE_CLIP_TEMPLATE_FAILURE';

export const deleteAfterEffectsClipTemplate = (templateId: string) => ({
  [RSAA]: {
    types: [
      DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST,
      {
        type: DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS,
        payload: () => ({ templateId }),
      },
      DELETE_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${templateId}`,
    method: 'DELETE',
  },
});

const DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST = 'DOWNLOAD_CLIP_TEMPLATE_REQUEST';
const DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS = 'DOWNLOAD_CLIP_TEMPLATE_SUCCESS';
const DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE = 'DOWNLOAD_CLIP_TEMPLATE_FAILURE';

export const downloadAfterEffectsClipTemplate = (templateId: string) => ({
  [RSAA]: {
    types: [
      DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST,
      {
        type: DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS,
        payload: () => ({ templateId }),
      },
      DOWNLOAD_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/download-template/${templateId}`,
    method: 'POST',
  },
});

const UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST = 'UPDATE_CLIP_TEMPLATE_REQUEST';
const UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS = 'UPDATE_CLIP_TEMPLATE_SUCCESS';
const UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE = 'UPDATE_CLIP_TEMPLATE_FAILURE';

export const updateAfterEffectsClipTemplate = (templateId: string, body: TemplateUpdateFormDataProps) => ({
  [RSAA]: {
    types: [
      UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_REQUEST,
      {
        type: UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_SUCCESS,
        payload: () => ({ body, templateId }),
      },
      UPDATE_AFTER_EFFECTS_CLIP_TEMPLATE_FAILURE,
    ],
    endpoint: `${BASE_ROUTE}/${templateId}`,
    method: 'PUT',
    body: toFormData(body),
  },
});
